import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["removeBtn", "undoBtn", "field", "persistedField", "destroyField", "message"]
  static classes = ["hide"]

  remove() {
    this.fieldTargets.forEach((field) => { field.disabled = true })
    if (this.hasPersistedFieldTarget && this.persistedFieldTarget.value === "") {
      useViewTransition(() => this.element.remove())
    } else {
      this.destroyFieldTarget.value = "1"
      this.removeBtnTarget.classList.add(this.hideClass)
      this.undoBtnTarget.classList.remove(this.hideClass)
      this.messageTarget.classList.remove(this.hideClass)
    }
  }

  undo() {
    this.fieldTargets.forEach((field) => { field.disabled = false })
    this.destroyFieldTarget.value = "0"
    this.removeBtnTarget.classList.remove(this.hideClass)
    this.undoBtnTarget.classList.add(this.hideClass)
    this.messageTarget.classList.add(this.hideClass)
  }
}

